import { getViolationMessage, violationDedupeKey } from './workflowValidation';

export function buildValidationListItems(violations) {
  return (violations || []).map((violation) => ({
    message: getViolationMessage(violation),
    severity: violation.severity || 'error',
    violation,
  }));
}

export function dedupeValidationListItems(items) {
  const seen = new Set();
  return (items || []).filter((item) => {
    if (!item?.message) return false;
    const key = item.violation ? violationDedupeKey(item.violation) : item.message;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

/**
 * Toolbar uses deduped validation items; publish bar falls back to server messages when none.
 */
export function buildPublishBarWarningItems(
  allValidationItems,
  dedupedToolbarItems,
  publishErrorMessages
) {
  if (allValidationItems.length > 0) return dedupedToolbarItems;
  return dedupeValidationListItems(
    (publishErrorMessages || []).map((message) => ({ message }))
  );
}
